var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.show
    ? _c(
        _setup.FormSidebarBtn,
        {
          attrs: { disabled: _setup.isDisabled },
          nativeOn: {
            click: function ($event) {
              $event.preventDefault()
              return _setup.onClick.apply(null, arguments)
            },
          },
        },
        [
          _c("i", { staticClass: "me-2 bi-subtract" }),
          _vm._v("\n    Duplicate\n"),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }